import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export interface OutlineContainerProps {
  padding?: boolean;
}

export const OutlineContainer = styled(Box)<OutlineContainerProps>`
  &&& {
    border-radius: var(--cl-radius-2);
    gap: var(--cl-space-3);
    padding: var(--cl-space-3);
    outline: .5px solid var(--cl-gray-500);
    ${({ padding }) => `padding:  ${padding
    ? 'var(--cl-space-5) var(--cl-space-6)'
    : 'var(--cl-space-3)'
  };`}
  }
`;

export const EditViewContainer = styled(Box)`
  &&& {
    gap: var(--cl-space-10);
    width: 100%;
  }
`;

export const StyledServiceCredentialsBanner = styled(Box)`
  &&& {
    width: 100%;
    height: 100%;
    padding: var(--cl-space-3) var(--cl-space-3);
    border: 1px solid var(--cl-border-focus-ring);
    border-radius: var(--cl-radius-2);
    justify-content: flex-start;
    gap: var(--cl-space-4);
  }
`;
